import { OccFirstVisitLogParams } from '@analytics/const';
import { Action } from '@ngrx/store';

export const FIRST_VISIT_LOG = '[Analytics] First Visit Log';

export class FirstVisitLog implements Action {
  readonly type = FIRST_VISIT_LOG;

  constructor(public payload: OccFirstVisitLogParams) {}
}

export type AnalyticsActions = FirstVisitLog;
